/* eslint-disable */
export default {
  to: '撥給：',
  transferTo: '轉接至',
  blindTransfer: '轉接',
  warmTransfer: '先詢問',
  enterNameOrNumber: '輸入號碼',
  toVoicemail: '至語音信箱',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To voicemail"@#@
